export const PRODUCT_CODES = {
    P002: 'PRODUCT_ALREADY_EXISTS',
    P003: 'PRODUCT_DISCOUNTED_PRICE_GREATER_THAN_PRICE',
};
